import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';


export default class ComboBoxHOC extends React.Component {
    static propTypes = {
        creatable: PropTypes.bool
    };

    static defaultProps = {
        creatable: false
    };

    onSelectMenuOpen = (e) => {
        let scrollable = $('.rie-scrollable');

        // if there are more than one scrollable, get the last one
        // this could happen if we are in a modal dialog on top of a page
        scrollable = $(scrollable[scrollable.length - 1]);

        // check if we need to scroll down vertically to have dropdown menu be in view
        if (scrollable.offset()) {
            const config = {};

            const viewportTop = scrollable.scrollTop();
            const viewportBottom = viewportTop + scrollable.height();

            let dropdown = null;
            setTimeout(() => {
                dropdown = $('.react-select__menu');

                if (dropdown[0]) {
                    const elem = dropdown[0];
                    const elemBottom = viewportTop + elem.getBoundingClientRect().bottom;

                    if (elemBottom > viewportBottom) {
                        config.scrollTop = viewportTop + (elemBottom - viewportBottom);
                    }

                    if (!_.isEmpty(config)) {
                        scrollable.animate(config, 1000, 'linear');
                    }
                }
            }, 200);


        }
    };

    render() {
        const ComboBoxComponent = this.props.creatable ? Creatable : Select;
        this.comboBoxRef = React.createRef();

        return (
            <ComboBoxComponent
                onMenuOpen={this.onSelectMenuOpen}
                {...this.props}
                ref={this.comboBoxRef}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/ComboBoxHOC.js